module.exports = __webpack_public_path__ + "static/media/highmark.053fe2a2.png";